import "../src/assets/styles/style.css";
import { ThemeProvider } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

import ApRoutes from "./routes";
import { createRef, forwardRef } from "react";
import { SnackbarProvider } from "notistack";
import theme from "./components/theme/MuiTheme1";
import { ContextAdmin } from "./hooks/AdminContext";
const NotistackProviderWithRef = forwardRef((props, ref) => (
  <SnackbarProvider ref={ref} {...props} />
));

function App() {
  const notistackRef = createRef();
  const onClickDismiss = (key) => () => {
    if (notistackRef.current) {
      notistackRef.current.closeSnackbar(key);
    }
  };

  return (
    <>
      <ContextAdmin>
        <ThemeProvider theme={theme}>
          <NotistackProviderWithRef
            ref={notistackRef}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            maxSnack={3}
            autoHideDuration={5000}
            action={(key) => (
              <div onClick={onClickDismiss(key)} className="pointer">
                <CloseIcon fontSize="small" className="me-2" />
              </div>
            )}
          >
            <ApRoutes />
          </NotistackProviderWithRef>
        </ThemeProvider>{" "}
      </ContextAdmin>
    </>
  );
}

export default App;
